import { Button, Progress } from 'antd';
// import "antd/dist/antd.css";
import { useRef } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import { useGlobalContext } from '../../context/GlobalContext';
import '../../global.css';
import { IPasswordChangeProfile } from '../../models/happy-code-api.model';
import { useNotificationService } from '../../services/notification.service';
import { useUsuarioService } from '../../services/usuario.service';
import './style.css';
import { useTranslation } from 'react-i18next';

const Senha: React.FunctionComponent = () => {
  const { usuario, setIsGlobalLoading } = useGlobalContext();
  const serviceUsuario = useUsuarioService();
  const password = useRef({});
  const navigate = useNavigate();
  const notification = useNotificationService();
  const { t } = useTranslation(['profile', 'common'])

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<IPasswordChangeProfile>();

  const save = (data: IPasswordChangeProfile) => {
    setIsGlobalLoading(true);
    serviceUsuario
      .alteraSenhaProfile(data)
      .then(() =>
        notification({
          message: t('common:success'),
          description: t('profile:successMessage'),
        }),
      )
      .finally(() => {
        setIsGlobalLoading(false);
        navigate('/usuarios/profile');
      });
  };

  password.current = watch('senha', '');

  return (
    <div className="container-fondo">
      <form
        onSubmit={handleSubmit(save)}
        className="container"
        style={{
          backgroundColor: 'var(--white-color',
          width: '100%',
          height: 'auto',
        }}
      >
        <Header />
        <div className="progress">
          <Progress
            className="progress-user"
            percent={20}
            strokeLinecap="square"
            showInfo={false}
          />
        </div>
        <div className="franquia" id="aluno-detalhe-row">
          <div className="user-row">
            <div className="box-title-senha">
              <h3 id="title-senha">{t('profile:changePassword')}</h3>
              <p>{t('profile:forgotPassword')}</p>
            </div>
            {/* <h6 id="sub-title-senha">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tristique quam tortor.</h6> */}
            <ul className="password-requisitos">
              <li>{t('profile:passwordRequirements.minLength')}</li>
              <li>{t('profile:passwordRequirements.uppercase')}</li>
              <li>{t('profile:passwordRequirements.number')}</li>
            </ul>
            <input
              type="hidden"
              value={usuario?.id}
              {...register('id', { required: true })}
            />
            <div className="input-box">
              <input
                type="password"
                placeholder={t('profile:currentPassword')}
                {...register('senhaAnterior', { required: true })}
              />
              {/* <Input placeholder="Senha Atual" id="senha-anterior" onChange={(e) => setSenhaNova({ ...senhaNova, senhaAnterior: e.target.value })} /> */}
            </div>
            <div className="input-box">
              <input
                type="password"
                placeholder={t('profile:newPassword')}
                {...register('senha', {
                  required: true,
                  pattern: /^(?=.*\d)(?=.*[A-Z])[0-9a-zA-Z!@#$%&*]{5,}$/,
                })}
              />
              {errors.senha && (
                <small className="input-error">
                  {t('profile:passwordInvalid')}
                </small>
              )}

              {/* <Input placeholder="Nova Senha" id="senha-nova" onChange={(e) => setSenhaNova({ ...senhaNova, senha: e.target.value })} /> */}
            </div>
            <div className="input-box">
              <input
                type="password"
                placeholder={t('profile:confirmPassword')}
                {...register('senhaConfirma', {
                  validate: (value) =>
                    value === password.current || t('profile:passwordMismatch'),
                })}
              />
              {errors.senhaConfirma && (
                <small className="input-error">
                  {t('profile:passwordInvalid')}
                </small>
              )}

              {/* <Input placeholder="Confirme a Nova Senha" id="senha-confirma" onChange={(e) => setSenhaNova({ ...senhaNova, senhaConfirma: e.target.value })} /> */}
            </div>
            <div className="botoes" id="botoes-senha">
              <Link to="/usuarios/profile">
                <Button
                  type="primary"
                  className="button-primary"
                  style={{ marginRight: 10 }}
                >
                  {t('profile:cancel')}
                </Button>
              </Link>
              <Button
                type="primary"
                htmlType="submit"
                className="button-second"
              >
                {t('profile:changePassword')}
              </Button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Senha;
